"use client";

import { useEffect, useState } from "react";
import PageNotFound from "views/Dashboard/PageNotFound";

// React Router matched paths case-insensitively and three pages used capitals; links already sent
// out (e.g. invoice previews) may still use them. Only the path prefix is corrected — the ids that
// follow are case-sensitive.
const LEGACY_PREFIXES = {
  "/client-Invoice-preview-mobile/": "/client-invoice-preview-mobile/",
  "/create-vehicle-Payment": "/create-vehicle-payment",
  "/vehicle-Payment-history": "/vehicle-payment-history",
};

export default function NotFound() {
  const [redirecting, setRedirecting] = useState(false);
  useEffect(() => {
    const { pathname, search, hash } = window.location;
    const legacy = Object.keys(LEGACY_PREFIXES).find((p) => pathname.startsWith(p));
    if (legacy) {
      setRedirecting(true);
      window.location.replace(LEGACY_PREFIXES[legacy] + pathname.slice(legacy.length) + search + hash);
    }
  }, []);
  if (redirecting) return null;
  return <PageNotFound />;
}
